import { FC, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { ehConsultor } from '@/components/layout/menu'

/**
 * Tela exclusiva do back-office: o consultor que chegar pela URL (link antigo,
 * favorito) volta ao dashboard. O menu já não mostra o item para ele (`menu.ts`).
 */
export const SomenteBackoffice: FC<{ children: ReactNode }> = ({ children }) => {
  const { usuario } = useAuth()
  return ehConsultor(usuario?.permissoes) ? <Navigate to="/dashboard" replace /> : <>{children}</>
}

export default SomenteBackoffice
